<template>
  <div id="map">
    <div id="leaflet"></div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import '../../styles/_variables.scss';
</style>
